import {
  IApiRequest,
  IApiToastMessageConfig,
  IPostIssueRequest,
} from "@miplatform/types";
import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ISSUES = `${TASK_SERVICE}/issues`;

export const issues = {
  getById: async ({ id, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_ISSUES}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });

    return apiRequest(options, toastMessageConfig);
  },
  getAll: async ({ filters, sort, params, signal, top, skip }: IApiRequest) => {
    const options = await apiOptions({
      url: API_ISSUES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  create: async ({
    data,
    toastMessageConfig,
  }: {
    data: IPostIssueRequest;
    toastMessageConfig?: IApiToastMessageConfig;
  }) => {
    const options = await apiOptions({
      url: API_ISSUES,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, toastMessageConfig, modifiedOn }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_ISSUES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });

    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_ISSUES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  resolve: async ({ id, data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_ISSUES}/${id}/resolve`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  cancel: async ({ id, data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_ISSUES}/${id}/cancel`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  confirm: async ({ id, data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_ISSUES}/${id}/confirm`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
};
